import React from 'react'
import { Badge } from '../badge'
import { Button } from '../button'
import { Icon } from '../icon'
import { BadgeProps } from 'antd'

import IconBell from '@organice/icons/bell.svg?react'
import IconBellRinging from '@organice/icons/bell-ringing.svg?react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

interface NotificationBellProps extends BadgeProps {
  active?: boolean
}

export const NotificationBell: React.FC<NotificationBellProps> = ({
  active,
  ...rest
}) => {
  const theme = useTheme()
  const { count, ...restWithoutCount } = rest
  const hasUnread = !!count
  return (
    <Badge
      color={theme.primaryColor}
      dot={hasUnread}
      offset={[-12, 6]}
      {...restWithoutCount}
    >
      <BellButton
        type="text"
        className={hasUnread ? 'active' : ''}
        icon={<Icon component={hasUnread ? IconBellRinging : IconBell} />}
      />
    </Badge>
  )
}

export const BellButton = styled(Button)(({ theme }) => ({
  width: '40px',
  height: '40px',
  '&:hover': {
    backgroundColor: theme.lightBackground,
  },
  svg: {
    fontSize: '24px',
  },
  '[class$="path"]': {
    fill: theme.iconBaseColor,
  },
  '[class$="shape"]': {
    fill: theme.iconShadeColor,
  },
  '&.active': {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '[class$="path"]': {
      fill: theme.iconActiveBaseColor,
    },
    '[class$="shape"]': {
      fill: theme.iconActiveShadeColor,
    },
  },
  border: 'none!important',
}))
